import { api } from "../store/middleware/api";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { authentication } from "../firebase";
import Swal from "sweetalert2";

const generateRecaptcha = () => {
  window.recaptchaVerifier = new RecaptchaVerifier(
    "recaptcha-container",
    {
      size: "invisible",
      callback: (response) => {},
    },
    authentication
  );
};

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAuthenticate: build.mutation({
      query: (body) => ({
        url: `/auth/login`,
        method: "POST",
        body,
      }),
    }),
    getValidatePhone: build.mutation({
      query: (body) => ({
        url: "/auth/phonecheck",
        method: "POST",
        body,
      }),
    }),
    changePassword: build.mutation({
      query: (body) => ({
        url: "/auth/changePassword",
        method: "POST",
        body,
      }),
    }),
    getLoginWithPhone: build.mutation({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const loginResponse = await fetchWithBQ({
          url: "/auth/password/less/login",
          method: "POST",
          body: _arg,
        });

        // if (loginResponse) {
        //   if (loginResponse.error)
        //     return Swal.fire("Failed!", loginResponse.error.data.message);

        //   generateRecaptcha();

        //   let appVerifier = window.recaptchaVerifier;
        //   signInWithPhoneNumber(authentication, `+${phone}`, appVerifier)
        //     .then((confirmationResult) => {
        //       window.confirmationResult = confirmationResult;
        //       return true;
        //     })
        //     .catch((error) => {
        //       console.log(error)
        //     });
        // }
        
        if (loginResponse.error) return loginResponse.error;
        if (loginResponse.data) {
          const userResponse = await fetchWithBQ({
            url: "/auth/dash",
            headers: {
              Authorization: `Bearer ${loginResponse.data.data.token}`,
            },
          });

          if (userResponse.data.status) {
            localStorage.setItem(
              "user",
              JSON.stringify(userResponse.data.data)
            );
            localStorage.setItem(
              "token",
              JSON.stringify(loginResponse.data.data.token)
            );
          }
          return loginResponse;
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAuthenticateMutation,
  useChangePasswordMutation,
  useGetValidatePhoneMutation,
  useGetLoginWithPhoneMutation,
} = extendedApi;
